import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { BadRequestHttpError } from '~shared/modules/error-handler';
import {
  IAdvancedFormConfig,
  IAdvancedFormContainer,
  IAdvancedFormEvent,
  AdvancedFormEventTypes,
} from '~shared/modules/advanced-form/models/advanced-form.model';

import { AccountManagementService } from '../../services/account-management.service';
import { AccountManagementDataService } from '../../services/account-management-data.service';
import { IBusinessInfo } from '../../models/account-info.model';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { PriceTypeService } from '~shared/modules/price-type-toggler/services/price-type.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-add-business-info',
  templateUrl: './add-business-info.component.html',
  styleUrls: ['./add-business-info.component.scss'],
})
export class AddBusinessInfoComponent implements OnInit, IAdvancedFormContainer {
  public advancedFormConfig$: Observable<IAdvancedFormConfig>;
  public alertConfig = {
    mode: 'alert',
    type: 'info',
    message: '',
    translation: 'PAGES.ACCOUNT.INFO.ADD_BUSINESS_INFO.ALERT.FILL_TO_VALIDATE',
  };

  constructor(
    private readonly translateService: TranslateService,
    private accountManagementDataService: AccountManagementDataService,
    private readonly accountManagementService: AccountManagementService,
    private priceTypeSvc: PriceTypeService,
  ) {
  }

  public ngOnInit(): void {
    this.translateService.get(this.alertConfig.translation)
      .pipe(take(1))
      .subscribe((translation) => {
      this.alertConfig.message = translation;
    });

    this.advancedFormConfig$ = this.accountManagementDataService.getAdvancedFormConfigForAddBusinessInfo();
  }

  public onAdvancedFormEvents(event: IAdvancedFormEvent): void {
    if (event.type === AdvancedFormEventTypes.submit) {
      this.handleSubmit(event);
    } else if (event.type === AdvancedFormEventTypes.skip) {
      this.handleSkip(event);
    }
  }

  private handleSubmit(event: IAdvancedFormEvent): void {
    const businessInfo = event.payload.formData as IBusinessInfo;

    this.accountManagementService.addBusinessInfo(businessInfo).subscribe(
      () => {
        event.done();
        this.priceTypeSvc.setPriceType(PriceTypes.b2b);
      },
      (error: BadRequestHttpError) => event.done(error.invalidParams),
    );
  }

  private handleSkip(event: IAdvancedFormEvent) {
    this.accountManagementService.skipAddingBusinessInfo().subscribe(
      () => event.done(),
      (error: BadRequestHttpError) => event.done(error.invalidParams),
    );
  }
}
